import { useTenant } from "../../../contexts/TenantContext";
import { findProvider } from "../providerChoice";
import ProviderTag from "./ProviderTag";

/**
 * The booking's provider, as a `ProviderTag` with their full name. Nothing on a tenant with one
 * provider, where the name says nothing the guest does not know, nor for a provider the tenant no
 * longer lists.
 */
const ProviderLine = ({ providerId, sx }) => {
  const { providers, hasSeveralProviders } = useTenant();
  const provider = hasSeveralProviders ? findProvider(providers, providerId) : undefined;
  if (!provider) return null;

  return <ProviderTag provider={provider} name={provider.name} fontSize={16} avatarSize={44} testId="provider-line" sx={sx} />;
};

export default ProviderLine;
